import * as traversal from '../../utilities/traversal';
import {domReady, windowLoaded} from '../../utilities/domready';
import { toCart } from './tocart';
import getHtmlParam from '../../utilities/htmlParam';

let mp = {} as Map<string, string>;
let listExpanded: Boolean = false;
const showmore = document.querySelector('.pda-overlay-accessory-table .toggle-more') as HTMLElement;
const overlayAccessoryContainer = document.querySelector('.pda-overlay-accessory-table');

export class Accessory {
  init() {
    windowLoaded(() => {
      const accessoryIncs = document.querySelectorAll('.product-accessory-row .accessory-incrementer');
      if (document.querySelector('.pda-accessory-table') && accessoryIncs[0]) {
        expandAccessory();
        initAccessoryIncrementer(accessoryIncs);
        new toCart().initAccessory();
        new toCart().initOverlayAccessory();
        intervalToggle();
        showAccessoryAsInterval();
      }
    });
  }
}

async function postData(url: string, data: Object) {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data)
  });
  return response;
}

function intervalToggle() {
    showmore && showmore.addEventListener('click', () => {
        const accessoryItems = document.querySelectorAll('.product-accessories-list .product-accessory-row');
        const hiddenAccessoryItems = document.querySelectorAll('.product-accessories-list .product-accessory-row.hidden');

        if (showmore.classList.contains('toggle-more-close')) {
            accessoryItems.forEach((item, index) => {
                if (index == 0) {
                    item.classList.add('last');
                } else {
                    item.classList.add('hidden');
                    item.classList.remove('last');
                }
            })
            showmore.classList.remove('toggle-more-close');
            showmore.innerHTML = '<span>' + mp.get('show_more') + '</span>';
            overlayAccessoryContainer && overlayAccessoryContainer.classList.add('_hasMore');
            overlayAccessoryContainer && overlayAccessoryContainer.classList.remove('_hasLess');
        } else {
            accessoryItems.forEach(item => {
                item.classList.remove('last');
            })
            for (let i = 0; i < hiddenAccessoryItems.length; ++i) {
                hiddenAccessoryItems[i].classList.remove('hidden');
                if (i+1 == hiddenAccessoryItems.length || i === 2) hiddenAccessoryItems[i].classList.add('last');
                if (i === 2) break;
            }
            if (hiddenAccessoryItems.length <= 3) {
                overlayAccessoryContainer && overlayAccessoryContainer.classList.remove('_hasMore');
                overlayAccessoryContainer && overlayAccessoryContainer.classList.add('_hasLess');
                showmore.innerHTML = '<span>' + mp.get('show_less') + '</span>';
                showmore.classList.add('toggle-more-close');
            }
        }
    });
}

function expandAccessory() {
    windowLoaded(() => {
        mp = getHtmlParam('.js-mp .param');
        let maxItems: number = 4;
        let container = document.querySelectorAll('.pda-accessory-table')[0];
        let accessories = document.querySelectorAll('.pda-accessory-table .product-accessory-row');
        container.setAttribute('style', 'height: auto');
        let innerHeight = (<HTMLElement>container).offsetHeight;
        let visibleRows: number = 0;
        let variantHeight = 50;

        let moreToggle = container.querySelectorAll('.toggle-more')[0];
        if(typeof moreToggle !== 'undefined') {
            moreToggle.parentNode.removeChild(moreToggle);
        }

        if(typeof accessories !== 'undefined') {

            for (let i = 0; i < accessories.length; ++i) {
                if(!accessories[i].classList.contains('hidden')) {
                    variantHeight = accessories[i].clientHeight;
                    break;
                }
            }

            accessories.forEach((item: HTMLElement) => {
                if(!item.classList.contains('hidden')) {
                    visibleRows = visibleRows + 1;
                }
            });
        }

        if(typeof accessories[0] !== 'undefined') {
            let maxHeight = maxItems * variantHeight + 40;
            if(visibleRows > maxItems) {
                container.classList.add('_hasMore');
                container.setAttribute('style', 'height: '+maxHeight+'px;');
                container.insertAdjacentHTML('beforeend', '<div class="toggle-more"><span>'+mp.get('show_more')+'</span></div>');

                domReady(() => {
                    let moreToggle = container.querySelectorAll('.toggle-more')[0];
                    moreToggle.addEventListener('click', () => {
                        if(container.classList.contains('_hasMore')) {
                            container.classList.remove('_hasMore');
                            container.classList.add('_hasLess');
                            container.setAttribute('style', 'height: auto;');
                            moreToggle.innerHTML = '<span>' + mp.get('show_less') + '</span>';
                            moreToggle.classList.add('toggle-more-close');
                            listExpanded = true;
                        } else {
                            container.classList.add('_hasMore');
                            container.classList.remove('_hasLess');
                            container.setAttribute('style', 'height: '+maxHeight+'px;');
                            moreToggle.innerHTML = '<span>' + mp.get('show_more') + '</span>';
                            moreToggle.classList.remove('toggle-more-close');
                            listExpanded = false;
                            window.scrollTo(window.scrollX, window.scrollY - innerHeight);
                        }
                    });

                    if(listExpanded == true) {
                        container.classList.remove('_hasMore');
                        container.classList.add('_hasLess');
                        container.setAttribute('style', 'height: auto;');
                        moreToggle.innerHTML = '<span>' + mp.get('show_less') + '</span>';
                        moreToggle.classList.add('toggle-more-close');
                    }
                });
            } else {
                container.classList.remove('_hasMore');
                container.classList.remove('_hasLess');
                container.setAttribute('style', 'height: auto;');
            }
        }
    });
}

//set clickListeners on quantity controls
function initAccessoryIncrementer(incrementerButtons: any) {
  if(typeof incrementerButtons !== 'undefined') {
    incrementerButtons.forEach((button: HTMLElement) => {
      button.addEventListener('click', () => {
        const input = button.closest('.accessory-form-field-incremeter').querySelector('.basket-quantity') as HTMLInputElement;
        const currentValue: number = parseInt(input.value);
        let newVal: number = 1;

        if (button.textContent === '+') {
          newVal = currentValue + 1;
            button.closest('.accessory-form-field-incremeter').querySelector('.incrementer-dec').classList.remove('incrementer-inactive');
        } else {
          // Don't allow decrementing below 1
          if (currentValue > 1) {
            newVal = currentValue - 1;
          } else {
            newVal = 1;
          }
          if (newVal <= 1) button.classList.add('incrementer-inactive');
          if (newVal > 1) button.classList.remove('incrementer-inactive');
        }

        input.value = newVal.toString();
      });
    });
  }
}

export function updateAccessory(articleId: string) {
  const table = document.getElementById('product-accessoires-table');
  if (table) {
    const accessoryProductIds = table
      .getAttribute('data-accessory-ids')
      .slice(0, -1)
      .split(',');
    loadAccessoryTable(articleId, accessoryProductIds, table);
    updateOverlayAccessory(articleId, accessoryProductIds);
    if(showmore) {
      showmore.innerHTML = '<span>' + mp.get('show_more') + '</span>';
    }
    overlayAccessoryContainer && overlayAccessoryContainer.classList.add('_hasMore');
  }
}

function loadAccessoryTable(articleId: string, accessoryProductIds: any, accessoryTable: HTMLElement) {

  const accessoryData = {} as any;
  accessoryData['productIds'] = accessoryProductIds;
  accessoryData['source'] = 'test-teco';
  accessoryData['refArticleId'] = articleId;

  const accessoryTableTarget: HTMLElement = accessoryTable.querySelector('.pda-accessory-table tbody');
  accessoryTableTarget.innerHTML = '';

  postData('/product/reco-tile/table/box/default/0/0/1', accessoryData)
    .then((response: any) => response.text())
      .then((text: any) => {
        accessoryTable.classList.remove('hidden');
        accessoryTableTarget.innerHTML = text;
        expandAccessory();
        initAccessoryIncrementer(document.querySelectorAll('.pda-accessory-table .accessory-incrementer'));
        new toCart().initAccessory();
    }).catch((err: any) => {
      console.log(err);
      accessoryTable.classList.add('hidden');
    });
}

function updateOverlayAccessory(articleId: string, accessoryProductIds: any) {
  const accessoryData = {} as any;

  const accessoryList = document.querySelector('.product-accessories-list');
  if (accessoryList) {
    accessoryData['productIds'] = accessoryProductIds;
    accessoryData['source'] = 'test-teco';
    accessoryData['refArticleId'] = articleId;

    accessoryList.innerHTML = '';

    postData('/product/reco-tile/rows/box/default/0/0/1', accessoryData)
    .then((response: any) => response.text())
      .then((text: any) => {
        accessoryList.innerHTML = text;
        initAccessoryIncrementer(document.querySelectorAll('.pda-overlay-accessory-table .accessory-incrementer'));
        new toCart().initOverlayAccessory();
        showAccessoryAsInterval();
    }).catch((err: any) => {
      console.log(err);
    });
  }
}

function showAccessoryAsInterval() {
  const rows = document.querySelectorAll('.product-accessories-list .product-accessory-row') as NodeList;
  rows.forEach((row: HTMLElement, index: number) => {
    if(!index) row.classList.add('last');
    index && row.classList.add('hidden');
  });
  overlayAccessoryContainer && overlayAccessoryContainer.classList.remove('_hasLess');
  overlayAccessoryContainer && overlayAccessoryContainer.classList.add('_hasMore');
  showmore && showmore.classList.remove('toggle-more-close');
}